var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBoxNextEnabled(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Rectangle_216",
    x: 0,
    y: 0,
    width: 48,
    height: 48,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "box_next_enabled",
    transform: "translate(-3718 -1824)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 3718, 1824)",
    filter: "url(#Rectangle_216)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_216-2",
    "data-name": "Rectangle 216",
    transform: "translate(9 6)",
    fill: "#fff",
    stroke: "#bfbfbf",
    strokeWidth: 0.5
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    rx: 5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.25,
    y: 0.25,
    width: 29.5,
    height: 29.5,
    rx: 4.75,
    fill: "none"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "right_next",
    d: "M102.923,6.594,98.4,11.753a.675.675,0,0,1-1.042,0,.926.926,0,0,1,0-1.188l4-4.566-4-4.565a.926.926,0,0,1,0-1.188.675.675,0,0,1,1.042,0l4.526,5.16a.926.926,0,0,1,0,1.188Z",
    transform: "translate(3642.861 1839)",
    fill: "#10374e"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBoxNextEnabled);
export default __webpack_public_path__ + "static/media/box_next_enabled.6be4c5327b5288ef1efeff5ca40877ec.svg";
export { ForwardRef as ReactComponent };